import React, { useEffect } from "react";
import { connect } from "react-redux";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import Grid from "@mui/material/Grid";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";
import ErrorIcon from "@mui/icons-material/Error";

import { Emphasize } from "../../../../styles";
import { csActions } from "../../../../../redux/actions";

const UnconnectedStep4Content = (props) => {
  useEffect(() => {
    if (
      props.visitorId
      && props.order
      && (props.order.bundle.name === "Bundle 2" || props.order.bundle.name === "Bundle 3")
    ) {
      props.claimThinkificDiscountCode(props.visitorId, props.order.id);
    }
  }, [props.visitorId, props.order])

  return (
    <>
      {props.isError &&
        <Grid container direction="row" alignItems="center" justifyContent="center" spacing="2px">
          <Grid item>
            <ErrorIcon color="error" fontSize="small" />
          </Grid>
          <Grid item>
            <Typography variant="caption" color="error">{props.errorMessage}</Typography>
          </Grid>
        </Grid>
      }
      <Typography>
        Thank you for your payment.
      </Typography>
      <Typography sx={{marginTop: "20px"}}>
        Here is your transaction reference ID: <Emphasize>{props.order.receipt.id}</Emphasize>
      </Typography>
      {props.order.bundle.name === "Bundle 1" &&
        <Typography sx={{marginTop: "20px"}}>
          Mark Laudi will now personally prepare your <Emphasize>HBM Communications Assessment Report</Emphasize> and email it to you in the next 48 hours.
        </Typography>
      }
      {props.order.bundle.name === "Bundle 2" &&
        <Typography sx={{marginTop: "20px"}}>
          You can now start our course "How to Present Live Webcasts Like a TV Anchor".
        </Typography>
      }
      {props.order.bundle.name === "Bundle 3" &&
        <Typography sx={{marginTop: "20px"}}>
          You can now start our course "Business Presentations for Future Leaders".
        </Typography>
      }
      {(props.order.bundle.name === "Bundle 2" || props.order.bundle.name === "Bundle 3") &&
        <>
          <Typography sx={{marginTop: "20px"}}>
            Note it down, register for the course by clicking the button below, and enter the code when prompted.
          </Typography>
          <Typography sx={{marginTop: "20px"}}>
            Here is your access code:&nbsp;
            {props.isClaimingThinkificDiscountCode &&
              <CircularProgress color="primary" size={16} />
            }
            {props.thinkificDiscountCode &&
              <Emphasize>{props.thinkificDiscountCode}</Emphasize>
            }
          </Typography>
          <Typography sx={{marginTop: "20px"}}>
            Mark Laudi will now personally prepare your <Emphasize>HBM Communications Assessment Report</Emphasize> and email it to you in the next 48 hours.
          </Typography>
        </>
      }
      {props.order.bundle.name === "Bundle 2" &&
        <Link
          href="https://hongbaomedia.thinkific.com/courses/tv-presenter-essentials"
          target="_blank"
          rel="noopener"
          sx={{textDecoration: "none"}}
        >
          <Button
            variant="contained"
            sx={{marginTop: "20px"}}
          >
            Access your course "How to Present Live Webcasts Like a TV Anchor"
          </Button>
        </Link>
      }
      {props.order.bundle.name === "Bundle 3" &&
        <Link
          href="https://hongbaomedia.thinkific.com/courses/business-presentations"
          target="_blank"
          rel="noopener"
          sx={{textDecoration: "none"}}
        >
          <Button
            variant="contained"
            sx={{marginTop: "20px"}}
          >
            Access your course "Business Presentations for Future Leaders"
          </Button>
        </Link>
      }
      {props.order.bundle.name === "Bundle 4" &&
        <>
          <Typography sx={{marginTop: "20px"}}>
            Mark Laudi will now personally prepare your <Emphasize>HBM Communications Assessment Report</Emphasize> and email it to you in the next 48 hours.
          </Typography>
          <Typography sx={{marginTop: "20px"}}>
            In the meantime, please proceed to book your first coaching session by clicking the button below.
          </Typography>
          <Link
            href="https://cliftonstrengths.timetap.com/"
            target="_blank"
            rel="noopener"
            sx={{textDecoration: "none"}}
          >
            <Button
              variant="contained"
              sx={{marginTop: "20px"}}
            >
              Book your first 2-hour session
            </Button>
          </Link>
        </>
      }
    </>
  )
}

const mapState = (state) => {
  const {
    order,
    isClaimingThinkificDiscountCode,
    thinkificDiscountCode,
    isError,
    errorMessage,
  } = state.cs;
  const { id } = state.visitor;
  return {
    order,
    isClaimingThinkificDiscountCode,
    thinkificDiscountCode,
    isError,
    errorMessage,
    visitorId: id,
  };
};

const actionCreators = {
  claimThinkificDiscountCode: csActions.claimThinkificDiscountCode,
};

export const Step4Content = connect(mapState, actionCreators)(UnconnectedStep4Content);